<template>
  <div>
    <section class="section is-main-section">
      <CardComponent class="content has-margin-top-30">
        <h1 class="title is-1">How it Works</h1>
        <p>
          Avails.Africa provides a centralised platform for buyers to
          efficiently and cost effectively license content for territories in
          Africa.
        </p>
        <p>
          Buyers can secure Pay or Free Rights for individual titles, content
          packages, linear channels and allows Free or Pay
          Broadcasters/Platforms to group their budgets together to access
          better quality entertainment. The platform serves as a showcase and
          aggregator and enables, a Group Buying cooperative that secures and
          showcases premium content For Africa, and From Africa.
        </p>
        <p>
          For the buyer, the platform provides an experience that streamlines
          the workflow into one portal for viewing, making selections and
          collections, and submitting offers. Bringing content to the decision
          makers and allowing the request of titles and genres that are in
          demand.
        </p>
      </CardComponent>
      <div class="content">
        <div class="columns">
          <div class="column">
            <CardComponent class="has-background-primary has-text-white">
              <h2 class="title is-2 has-text-white">Free Rights</h2>
              <p>
                For the most part FTA broadcasters and platforms monetise within
                their own territory, or distribution type, and don’t compete
                with each other. The need for Pan-African exclusivity is very
                rare, and this allows them the opportunity to use the
                fragmentation of the market and continent to their advantage. It
                does however require a central, cooperative platform that allows
                for group buying and aggregation of revenues, and Avails.Africa
                does exactly that.
              </p>
              <p>Please see 90” explainer video below</p>
              <p>
                The platform can also do traditional license deals and direct
                sales for the exclusive request and mirror the windowing of
                content within similar territories if multiple FTA’s require
                similar titles.
              </p>
              <CloudflareVideoPlayer
                video-id="284d3869f1d7828c84e6334b0330f89a"
              />
            </CardComponent>
          </div>
          <div class="column">
            <CardComponent class="has-background-info has-text-white">
              <h2 class="title is-2 has-text-white">Pay Rights</h2>
              <p>
                The need for Pan-African rights are more common with Pay rights,
                but within these restrictions Avails.Africa can turn the small
                market size and fragmentation to the advantage of both the
                seller and the buyer. Rights can be granted non-exclusively, or
                carved out within territory or distribution type, allowing the
                same principle of shared expenses and group buying to apply.
              </p>
              <p>
                Traditional first Run, exclusive deals can also be done through
                the platform, and then showcased on the for future availability
                when holdbacks are over.
              </p>
            </CardComponent>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import CardComponent from '@/components/CardComponent'
import CloudflareVideoPlayer from '@/components/CloudflareVideoPlayer'
export default {
  name: 'HowItWorks',
  components: {
    CardComponent,
    CloudflareVideoPlayer
  },
  metaInfo: {
    title: 'How it Works',
    meta: [
      {
        vmid: 'description',
        name: 'description',
        content:
          'Avails.Africa provides a centralised platform for buyers to efficiently and cost effectively license content for territories in Africa.'
      }
    ]
  },
  data() {
    return {}
  },
  computed: {},
  mounted() {},
  methods: {}
}
</script>
